import { useMediaQuery } from '@material-ui/core';
import React from 'react';
import { MUI_DESKTOP_BREAKPOINT, MUI_MOBILE_BREAKPOINT, MUI_TABLET_BREAKPOINT } from '../../../utils/constants';
import { SearchForm } from './SearchForm';

type devices = 'desktop' | 'mobile' | 'tablet';

const SearchFormWrapper = ({
  targetDevices,
  desktopVersionOnTablet = false,
}: {
  targetDevices?: devices[];
  desktopVersionOnTablet?: boolean;
}) => {
  const currentBreakPoint: Record<string, boolean> = {
    mobile: useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true }),
    desktop: useMediaQuery(MUI_DESKTOP_BREAKPOINT, { noSsr: true }),
    tablet: useMediaQuery(MUI_TABLET_BREAKPOINT, { noSsr: true }),
  };

  let shouldRenderSearchInstance = false;
  if (!targetDevices || targetDevices.length === 0) {
    shouldRenderSearchInstance = true;
  } else if (targetDevices && targetDevices?.length === 1) {
    if (targetDevices[0] && currentBreakPoint[targetDevices[0]]) {
      shouldRenderSearchInstance = true;
    }
  } else if (targetDevices && targetDevices.length > 1) {
    targetDevices?.forEach((target) => {
      if (target && currentBreakPoint[target]) shouldRenderSearchInstance = true;
    });
  }

  return shouldRenderSearchInstance ? <SearchForm desktopVersionOnTablet={desktopVersionOnTablet} /> : null;
};

export default SearchFormWrapper;
